import React, { useEffect, useState } from "react";
import { semcastAxios } from "../../Utils/Common";
import { SYSTEM_NOTIFICATIONS_API, SUCCESS_STATUS } from "../../api/constants";
import NotificationBanner from "./SharedComponents/SystemNotificationBanner";
import "./SystemNotificationBanner.css";

const BANNER_DISMISS_KEY = "dismissedSystemNotifs";

const GlobalNotificationBanner = () => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await semcastAxios.get(SYSTEM_NOTIFICATIONS_API, {
          withCredentials: true,
        });
  
        if (response?.data?.status !== SUCCESS_STATUS) return;
  
        const notificationsList = Array.isArray(response?.data?.data)
          ? response.data.data
          : [];
  
        const dismissed = JSON.parse(localStorage.getItem(BANNER_DISMISS_KEY)) || {};
        const now = Date.now();
  
        const active = notificationsList.filter((notif) => {
          const dismissedTime = dismissed[notif.id];
          const isDismissed = dismissedTime && now - dismissedTime <= 43200000;
  
          const isActive = notif.status === "active";
          const isNotExpired = !notif.expiresAt || new Date(notif.expiresAt).getTime() > now;
  
          return !isDismissed && isActive && isNotExpired;
        });
  
        setNotifications(active);
      } catch (err) {
        console.error("Error fetching system notifications:", err);
        setNotifications([]);
      }
    };
  
    // Initial fetch
    fetchNotifications();
  
    // Set up polling every 30 seconds
    const intervalId = setInterval(() => {
      fetchNotifications();
    }, 30000); // 30,000ms = 30 seconds
  
    // Cleanup on unmount
    return () => clearInterval(intervalId);
  }, []);
  

  const handleDismiss = (id) => {
    const dismissed = JSON.parse(localStorage.getItem(BANNER_DISMISS_KEY)) || {};
    dismissed[id] = Date.now();
    localStorage.setItem(BANNER_DISMISS_KEY, JSON.stringify(dismissed));
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  };

  if (!notifications.length) return null;

  return (
    <div className="global-notification-banner-wrapper">
      {notifications.map((notif) => (
        <NotificationBanner
          key={notif.id}
          notif={notif}
          onDismiss={() => handleDismiss(notif.id)}
        />
      ))}
    </div>
  );
};

export default GlobalNotificationBanner;
